import type {Agent} from 'services/agent/types';
import {isAgentSubType} from './isAgentSubType';

export const isAgentValue = (value: unknown): value is Agent =>
  typeof value === 'object' && isAgentSubType((value as Agent).agentType);
